import { render, staticRenderFns } from "./InputBoolean.vue?vue&type=template&id=28d71ca9"
import script from "./InputBoolean.vue?vue&type=script&lang=js"
export * from "./InputBoolean.vue?vue&type=script&lang=js"
import style0 from "./InputBoolean.vue?vue&type=style&index=0&id=28d71ca9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports